import { Component, Input, OnInit, Optional } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-how-works',
  templateUrl: './how-works.component.html',
  styleUrls: ['./how-works.component.css']
})
export class HowWorksComponent implements OnInit {
  pageName: any;
  pagFaqUrl: any;
  howPageWorkData: any;
  @Input() pageWorks !: any;
  @Input() fromParent: any;
  constructor(
    @Optional() public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) { }

  ngOnChanges(changes: any) {
    if (changes && changes?.pageWorks) {
      this.howPageWorkData = changes?.pageWorks.currentValue;
      this.pageName = this.howPageWorkData.pageName;
      this.pagFaqUrl = this.getSanitizeUrl(this.howPageWorkData.pagFaqUrl);
      //console.log(this.howPageWorkData);
    }
  }

  ngOnInit() {
    if (this.fromParent) {
      this.pageName = this.fromParent.pageName;
      this.pagFaqUrl = this.getSanitizeUrl(this.fromParent.pagFaqUrl);
    }
  }

  closeModal(sendData: any) {
    this.activeModal.close(sendData);
  };

  getSanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
